import Multilingual from '~~utils/Multilingual';

const localMapping = {
  MY_PLUGIN_ORDER: {
    'zh-TW': '擴充套件訂單',
    en: 'Plugin Order List',
  },
  UNIQID: {
    'zh-TW': '訂單編號',
    en: 'Order ID',
  },
  STATUS: {
    WORDING: {
      'zh-TW': '狀態',
      en: 'Status',
    },
    PENDING_PAYMENT: {
      'zh-TW': '未付款',
      en: 'Pending Payment',
    },
    PAYMENT_FAILURE: {
      'zh-TW': '付款失敗',
      en: 'Payment Failure',
    },
    CREATED: {
      'zh-TW': '成立',
      en: 'Created',
    },
    CANCELED: {
      'zh-TW': '已取消',
      en: 'Canceled',
    },
    REFUND_REQUESTED: {
      'zh-TW': '申請退款',
      en: 'Refound Requested',
    },
    REFUNDED: {
      'zh-TW': '已退款',
      en: 'Refunded',
    },
    NONE: {
      'zh-TW': '無',
      en: 'None',
    },
  },
  PAYMENT_AMOUNT: {
    'zh-TW': '金額',
    en: 'Payment',
  },
  CREATED_AT: {
    'zh-TW': '下單時間',
    en: 'Created At',
  },
  RECEIPT_TYPE: {
    PERSONAL: {
      'zh-TW': '個人',
      en: 'Personal',
    },
    DONATE: {
      'zh-TW': '捐贈',
      en: 'Donate',
    },
    COMPANY: {
      'zh-TW': '公司（統編）',
      en: 'Company',
    },
  },
};

const multi = (textCode, lang = '') => {
  return Multilingual(textCode, localMapping, lang);
};
export default multi;
